function csvEscape(value) {
  const s = value === null || value === undefined ? '' : String(value);
  if (/[",\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

// columns: [{ header, key }] or [{ header, value: (row) => any }]
export function downloadCsv(filename, columns, rows) {
  const header = columns.map(c => csvEscape(c.header)).join(',');
  const lines = rows.map(row =>
    columns.map(c => csvEscape(c.value ? c.value(row) : row[c.key])).join(',')
  );
  const csv = [header, ...lines].join('\r\n');
  // Leading BOM so Excel correctly detects UTF-8 (₹ symbol etc.)
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Repeatedly calls fetchPage(page, perPage) until all pages of a paginated
// { data, pagination: { pages } } response have been collected.
export async function fetchAllPages(fetchPage, { perPage = 100 } = {}) {
  let page = 1;
  let all = [];
  for (;;) {
    const res = await fetchPage(page, perPage);
    const data = res.data || [];
    all = all.concat(data);
    const pages = res.pagination?.pages || 1;
    if (page >= pages || data.length === 0) break;
    page += 1;
  }
  return all;
}
